import { render, staticRenderFns } from "./TaxonomiesView.vue?vue&type=template&id=dca6ee4a&scoped=true"
import script from "./TaxonomiesView.vue?vue&type=script&lang=js"
export * from "./TaxonomiesView.vue?vue&type=script&lang=js"
import style0 from "./TaxonomiesView.vue?vue&type=style&index=0&id=dca6ee4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dca6ee4a",
  null
  
)

export default component.exports